/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Metadata_KeyInputs */

const id_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci`)
};

const ms_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci`)
};

const da_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nøgle`)
};

const de_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel`)
};

const en_us2_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key`)
};

const es_es2_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave`)
};

const es_mx2_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave`)
};

const fil_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key`)
};

const fr_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé`)
};

const it_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave`)
};

const hu_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulcs`)
};

const nl_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleutel`)
};

const no_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nøkkel`)
};

const pl_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klucz`)
};

const pt_br2_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave`)
};

const pt_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave`)
};

const ro_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheie`)
};

const fi_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avain`)
};

const sv_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyckel`)
};

const vi_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khóa`)
};

const tr_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtar`)
};

const cs_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíč`)
};

const bg_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключ`)
};

const ru_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключ`)
};

const uk_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключ`)
};

const ar_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المفتاح`)
};

const hi_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी`)
};

const th_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คีย์`)
};

const ja_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キー`)
};

const zh_cn2_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`键`)
};

const zh_hant1_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鍵`)
};

const ko_items_metadata_key = /** @type {(inputs: Items_Metadata_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키`)
};

/**
* | output |
* | --- |
* | "Key" |
*
* @param {Items_Metadata_KeyInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_metadata_key = /** @type {((inputs?: Items_Metadata_KeyInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Metadata_KeyInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_metadata_key(inputs)
	if (locale === "ms") return ms_items_metadata_key(inputs)
	if (locale === "da") return da_items_metadata_key(inputs)
	if (locale === "de") return de_items_metadata_key(inputs)
	if (locale === "en-US") return en_us2_items_metadata_key(inputs)
	if (locale === "es-ES") return es_es2_items_metadata_key(inputs)
	if (locale === "es-MX") return es_mx2_items_metadata_key(inputs)
	if (locale === "fil") return fil_items_metadata_key(inputs)
	if (locale === "fr") return fr_items_metadata_key(inputs)
	if (locale === "it") return it_items_metadata_key(inputs)
	if (locale === "hu") return hu_items_metadata_key(inputs)
	if (locale === "nl") return nl_items_metadata_key(inputs)
	if (locale === "no") return no_items_metadata_key(inputs)
	if (locale === "pl") return pl_items_metadata_key(inputs)
	if (locale === "pt-BR") return pt_br2_items_metadata_key(inputs)
	if (locale === "pt") return pt_items_metadata_key(inputs)
	if (locale === "ro") return ro_items_metadata_key(inputs)
	if (locale === "fi") return fi_items_metadata_key(inputs)
	if (locale === "sv") return sv_items_metadata_key(inputs)
	if (locale === "vi") return vi_items_metadata_key(inputs)
	if (locale === "tr") return tr_items_metadata_key(inputs)
	if (locale === "cs") return cs_items_metadata_key(inputs)
	if (locale === "bg") return bg_items_metadata_key(inputs)
	if (locale === "ru") return ru_items_metadata_key(inputs)
	if (locale === "uk") return uk_items_metadata_key(inputs)
	if (locale === "ar") return ar_items_metadata_key(inputs)
	if (locale === "hi") return hi_items_metadata_key(inputs)
	if (locale === "th") return th_items_metadata_key(inputs)
	if (locale === "ja") return ja_items_metadata_key(inputs)
	if (locale === "zh-CN") return zh_cn2_items_metadata_key(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_metadata_key(inputs)
	return ko_items_metadata_key(inputs)
});
export { items_metadata_key as "items.metadata.key" }